<template>
  <nuxt-link :to="{ name: 'index' }" title="Mandala Group">
    <!-- Mandala (imagen/parche-marca.py): al inicio de la instancia, no a baserow.io. -->
    <Logo height="14" alt="Mandala Group" />
  </nuxt-link>
</template>

<script>
export default {
  name: 'ExternalLinkBaserowLogo',
}
</script>
